<template>
  <div class="notification-page">
    <!-- HEADER -->
    <div class="notification-header">
        <h4 class="notification-title mb-0 mr-auto">
          Notifications
        </h4>
        <b-badge
          pill
          variant="light-primary"
        >
          6 New
        </b-badge>
    </div>
    <div class="notification-list">
      <b-link
        class="notification-list-item"
        v-for="notification in notifications"
        :key="notification.title"
      >
        <b-media>
          <template #aside>
            <b-avatar
              size="32"
              src="@/assets/images/logo/logo.svg"
            />
          </template>
          <p class="media-heading">
            <span class="font-weight-bolder">
              {{ notification.title }}
            </span>
          </p>
          <small class="notification-text">{{ notification.message }}</small>
        </b-media>
      </b-link>
    </div>
  </div>
</template>

<script>
import {
  BBadge, BMedia, BLink, BAvatar,
} from 'bootstrap-vue';

export default {
  data() {
    return {};
  },
  methods: {
    notificationImagePath(item) {
        if (item.image_path) {
            return item.image_path;
        }
        return '@/assets/images/logo/logo.svg';
    },
  },
  computed: {
    notifications() {
      return this.$store.state.notifications;
    },
  },
  components: {
    BBadge, BMedia, BLink, BAvatar,
  }
};
</script>

<style>
</style>